export enum ButtonVariation {
  Primary = 'primary',
  PrimaryInversed = 'primary-inversed',
  Secondary = 'secondary',
  Neutral = 'neutral',
  Danger = 'danger',
  DangerInversed = 'danger-inversed',
  Success = 'success',
  Link = 'link',
  AI = 'ai',
  Light = 'light'
}
